export default "__VITE_ASSET__jmnNsTbY__"